import React from 'react';
import { SBrandImageBox } from 'pages/TiresPage/TireReferencesSection/TireReferenceCard/TireReferenceCard.styled';

interface BrandImageWrapperProps extends React.PropsWithChildren {
  availableInUserCountry: boolean;
}

export const BrandImageWrapper = ({ children, availableInUserCountry }: BrandImageWrapperProps) => {
  if (availableInUserCountry) {
    return <>{children}</>;
  }
  return <SBrandImageBox>{children}</SBrandImageBox>;
};
